import React from 'react'
import { ChainId } from '@yetiswap/sdk'
import { ReactComponent as PriceTags } from '../../../../assets/images/price-tags.svg'
import { ReactComponent as Removed } from '../../../../assets/images/x.svg'
import YTSLogo from '../../../../assets/logo/token-logo.png'
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { ReactComponent as AlertIcon } from '../../../../assets/svg/alert.svg'
import { ReactComponent as ForkIcon } from '../../../../assets/svg/git-fork.svg'
import { ExternalLink } from 'react-feather'
import { NavLink, useHistory } from 'react-router-dom'
import { YTS } from '../../../../constants'
import { useGetSaleTokenItem, useGetNFTPrice } from '../../../../hooks/useNFTMarketPlace'
import { TYPE } from '../../../../theme'
import { getEtherscanLink } from '../../../../utils'
import NFTPriceSymbol from '../../components/NFTPriceSymbol'
import { NFTURLItems } from '../../data/NFTURLItems'
import { NFTHistoryItemWrapper } from '../../pages/Profile/History/styled'
import { getWalletAddress } from '../../utils/NFTFormatedData'
import { IActivityDetail } from './ActivityDetail'
import { ActivityListItem, ActivityListImage, ActivityItemInfo, ActivityItemCollection, ActivityItemTitle, ActivityItemText } from '../../newComponents/NFTActivityList/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShop, faShopSlash, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";

export interface IActivityIcon {
	[key: string]: any
}

export default function BaseActivity({ historyItem, collection, children, tokenName, chainId }: IActivityDetail) {
	const { action, timestamp, transactionHash, tokenId, account, opponent, saleToken, price } = historyItem
	const tokenLink = `${NFTURLItems.NFT_DETAIL}/${collection.tokenAddress}/${tokenId}`
	const location = useHistory();
	const dateTime = new Date(parseInt(timestamp) * 1000)
	const userAccount = getWalletAddress(account, 6)
	const userOpponent = getWalletAddress(opponent, 6)
	const yts = chainId !== undefined ? YTS[chainId] : YTS[ChainId.AVALANCHE]
	const saleTokenItem = useGetSaleTokenItem(saleToken)
	const NFTTokenPrice: string = useGetNFTPrice(price, yts, true)
	const tokenPrice = (
		<span style={{ margin: '0 5px', display: 'flex' }} >
			{NFTTokenPrice} {<NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />}
		</span>
	)

	const ActivityIcon: IActivityIcon = {
		Listed: <PriceTags className="listed" title="Listed" />,
		Buy: <img src={YTSLogo} alt="Purchased" title="Purchased" />,
		Sold: <img src={YTSLogo} alt="Sold" title="Sold" />,
		Removed: <Removed className="removed" title="Removed" />
	}

	const activity = ActivityIcon[action]

	function getDescription() {
		let message = <></>

		const userAccountLink = (
			<span style={{ margin: '0 5px', cursor: "pointer", textDecoration: "underline" }} onClick={() =>
				location.push(`/profile/${account}?tab=on-sale`)
			}>
				{userAccount}
			</span>
		)
		const userOpponentLink = (
			<span style={{ margin: '0 5px', cursor: "pointer", textDecoration: "underline" }} onClick={() =>
				location.push(`/profile/${opponent}?tab=on-sale`)
			}>
				{userOpponent}
			</span>
		)

		if (action === 'Listed') {
			message = (
				<>
					Listed by {userAccountLink} for {tokenPrice}
				</>
			)
		} else if (action === 'Buy') {
			message = (
				<>
					Purchased by {userAccountLink} for {tokenPrice} from {userOpponentLink}
				</>
			)
		} else if (action === 'Sold') {
			message = (
				<>
					Purchased by {userOpponentLink} for {tokenPrice} from {userAccountLink}
				</>
			)
		} else if (action === 'Removed') {
			message = <>Removed by {userAccountLink}</>
		}

		return message
	}

	function getIcon() {
		switch (action) {
			case 'Listed':
				return (<FontAwesomeIcon icon={faShop} size={"1x"} style={{ marginRight: 5 }} />);
			case 'Buy':
				return (<FontAwesomeIcon icon={faMoneyCheckDollar} size={"1x"} style={{ marginRight: 5 }} />);
			case 'Sold':
				return (<FontAwesomeIcon icon={faMoneyCheckDollar} size={"1x"} style={{ marginRight: 5 }} />);
			case 'Removed':
				return (<FontAwesomeIcon icon={faShopSlash} size={"1x"} style={{ marginRight: 5 }} />);
			default:
				return <></>;
		}
	}

	const onClick = () => {
		location.push(tokenLink)
	}

	return (
		<ActivityListItem>
			<ActivityListImage onClick={onClick}>
				{children}
			</ActivityListImage>
			<ActivityItemInfo>
				{collection.tokenAddress !== '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d' &&
					<ActivityItemCollection title={`${collection.name} Verified Collection`} onClick={() =>
						location.push(`/collection/${collection.tokenAddress}`)
					}>

						{collection.forkProject && (
							<ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
						)}
						{collection.oldProject && (
							<AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
						)}
						<VerifiedIcon width="1rem" />
						{collection.name}
					</ActivityItemCollection>
				}
				<ActivityItemTitle onClick={onClick}>{tokenName}</ActivityItemTitle>
				<ActivityItemText>{getDescription()}{" at "}{dateTime.toLocaleString()}</ActivityItemText>
				{chainId && transactionHash && (
					<ActivityItemText style={{ textDecoration: 'underline' }} onClick={() => {
						window.open(getEtherscanLink(chainId, transactionHash, 'transaction'))
					}}>
						View transaction on the SnowTrace
					</ActivityItemText>
				)}
			</ActivityItemInfo>
			{getIcon()}
		</ActivityListItem>
	)
}
